import React, { createContext, useContext, useState, ReactNode } from "react";
import ConfirmationModal from "./components/confirmationModal";

type ConfirmationContextType = {
  requestConfirmation: (message: string) => Promise<boolean>;
};

const ConfirmationContext = createContext<ConfirmationContextType | undefined>(undefined);

export const ConfirmationProvider = ({ children }: { children: ReactNode }) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [resolvePromise, setResolvePromise] = useState<((value: boolean) => void) | null>(null);

  const requestConfirmation = (message: string) => {
    return new Promise<boolean>((resolve) => {
      setMessage(message);   // Set the confirmation message
      setResolvePromise(() => resolve);  // Save the resolve function
      setModalOpen(true);   // Open the modal
    });
  };

  const handleConfirm = (value: boolean) => {
    console.log('clicked');
    console.log(value);
    if (resolvePromise) {
      resolvePromise(value);   // Resolve the promise with the user's choice
    }
    setModalOpen(false);      // Close the modal
  };

  return (
    <ConfirmationContext.Provider value={{ requestConfirmation }}>
      {children}
      {/* Global modal, no need to add manually */}
      {isModalOpen && (
        <ConfirmationModal
          title={message}
          isOpen={isModalOpen}
          onConfirm={handleConfirm}
          setOpen={setModalOpen}
        />
      )}
    </ConfirmationContext.Provider>
  );
};

// Custom hook to use the confirmation dialog
export const useConfirmation = () => {
  const context = useContext(ConfirmationContext);
  if (!context) {
    throw new Error("useConfirmation must be used within a ConfirmationProvider");
  }
  return context.requestConfirmation;
};
